export const TEXTS = {
  MEASUREMENT_FOR: (name = '') => `Measurements for ${name}`,
  SELECT_SIZE: 'Select Size',
  SIZE_GUIDE: 'Size Guide',
};

export const TRACKING_KEY = 'sizeGuideClick:selectSize';
export const SOLD_OUT_LEGEND = 'Sold out';
export const FEW_LEFT_LEGEND = 'Few left';
export const WIDTH_OFFSET = 8;
export const SIZE_SECTION_V2_CONFIG = 'pdpSizeSectionV2Enabled';
export const WINDOW_SCROLL_OFFSET = 140;
export const SCROLL_DELAY = 100;
